app.factory('payment', ['$http', 'Config', '$rootScope', 'CacheFactory', function ($http, Config, $rootScope, CacheFactory) {

	var factoryFns = {
		incrementOrder: function (webQuoteID) {
			return $http({
				method: 'POST',
				url: Config.api_url + 'order/increment?brand=' + Config.brand_key + '&web-quote-id=' + webQuoteID,
				headers: {
					'authorization': Config.api_key
				}
			});
		},
		processPayment: function (data) {
			return $http({
				method: 'POST',
				data: data,
				url: Config.base_url + 'checkout/complete-payment',
				headers: {
					'authorization': Config.api_key
				}
			});
		},
		saveOrder: function (data) {
			return $http({
				method: 'POST',
				data: data,
				url: Config.api_url + 'order/save',
				headers: {
					'authorization': Config.api_key
				}
			});
		},
		saveBuyOrder: function (data) {
			return $http({
				method: 'POST',
				data: data,
				url: Config.api_url + 'order/save-buy',
				headers: {
					'authorization': Config.api_key
				}
			});
		},
		convertDorisToHerbertAddress: function (address, quote) {
			return {
				'postcode': address.postCode,
				'company': address.company,
				'address_1': address.address_line_1,
				'address_2': address.address_line_2,
				'town': address.town,
				'county': address.county,
				'country': address.country,
				'firstname': address.contactName,
				'email': quote.email,
				'telephone': address.contactPhone,
				'floor_level': address.floor,
				'lift_access': address.lift,
				'lift_big_enough': address.liftFit,
				'additional_info': address.additional,
				'parking_restrictions': address.parkingRestriction,
				'del_col_contact_name': address.contactName,
				'del_col_contact_number': address.contactPhone
			}
		}
	}
	return factoryFns;

}]);